// Polyfill for older browsers
// import "core-js";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

// Bootstrap styling
import "./bootstrap-custom.scss";

// Root level styles
import "./index.css";

// React libraries
import React, { Suspense } from "react";
import ReactDOM from "react-dom";

import "./i18n/i18n";

import App from "./App";
import Loading from "./components/Loading";

ReactDOM.render(
  <Suspense fallback={<Loading />}>
    <App />
  </Suspense>,
  document.getElementById("root")
);
